<template>
  <div class="page-full py-4">
    <div class="container">
      <!-- <CardShadow>
        <div class="py-1 px-2">
          Publicidad
        </div>
        <img src="https://picsum.photos/1200/100" alt="" class="img-fluid">
      </CardShadow> -->
      <div class="row">
        <div class="col-md-8 pb-3">
          <CardShadow>
            <CardVs>
              <h4>
                Ingresa tu código de reserva.
              </h4>
              <hr>
              <form action="#" @submit.prevent="onSubmitForm()" class="px-0 px-lg-5">
                <div class="form-group mb-3">
                  <!--<label class="text-uppercase font-xs">Ingresa tu código de reserva</label>-->
                  <br>
                  <input
                    v-model="form.code"
                    type="text" placeholder="Ejm: A01BCD"
                    class="form-control card-code__input"
                    :class="{'is-invalid': error}"
                    required
                    autocomplete="off"
                  >
                  <div class="invalid-feedback text-center">
                    {{ error }}
                  </div>
                </div>
                <p>
                  <button
                    type="submit"
                    :disabled="!form.code"
                    class="btn btn-secondary btn-block text-uppercase font-s py-2"
                  >
                    <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                    <b> VALIDAR</b>
                  </button>
                </p>
                <div class="text-center mt-5">
                  <a href="#" @click.prevent="modalResend = true" class="small">
                    <b>No me llego mi código</b>
                  </a>
                </div>
              </form>
            </CardVs>
          </CardShadow>
          <div class="d-none">
            <CardShadow>
              <a href="https://www.joinnus.com/deportes/lima-peru-vs-chile-reserva-tu-estacionamiento-33997" target="_blank">
                <img src="/images/estacionamientos.png" alt="Jn" class="img-fluid">
              </a>
            </CardShadow>
          </div>
          <div role="tablist">
            <b-card v-for="(faq, idx) in faqs" :key="idx" no-body class="mb-3">
              <b-card-header header-tag="header" class="p-2 card-header--white" role="tab">
                <div block href="#" v-b-toggle="`collapse-faq-${idx}`" variant="info"
                  class="p-2 d-flex justify-content-between align-items-center el-pointer">
                  <h4 class="card-title mb-0">
                    {{ faq.title }}
                  </h4>
                  <span class="float-right">
                    Ver
                  </span>
                </div>
              </b-card-header>
              <b-collapse :id="`collapse-faq-${idx}`" accordion="faq-accordion" role="tabpanel">
                <b-card-body>
                  <b-card-text>
                    {{ faq.description }}
                  </b-card-text>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
        <div class="col-md-4">
          <CardShadow>
            <div class="d-none d-md-block">
              <img src="/images/banners/banner-vert.png" alt="Banner" class="img-fluid">
            </div>
            <div class="d-block d-md-none">
              <img src="/images/banners/banner-hor.png" alt="Banner" class="img-fluid">
            </div>
          </CardShadow>
          <CardShadow>
            <div>
              <img src="/images/banners/banner-dni.png" alt="Banner" class="img-fluid">
            </div>
          </CardShadow>
        </div>
      </div>
    </div>
    <b-modal v-model="modalResend" hide-header hide-footer size="sm" centered>
      <a href="#" @click.prevent="modalResend = false" class="btn-close-modal-intern">
        <i class="fa fa-times text-dark"></i>
      </a>
      <div class="d-block">
        <form @submit.prevent="onSubmitResend()" action="#">
          <div class="card-code p-4">
            <div class="row">
              <div class="col-12">
                <h4>No me llego mi código de canje</h4>
                <hr>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="d-block">
                    <span class="font-xs">INGRESA TU CORREO</span>
                    <input
                      v-model="formResend.email"
                      type="email"
                      maxlength="120"
                      class="form-control"
                      required autocomplete="off"
                      :class="{'is-invalid': this.errorResend}"
                    >
                    <div class="invalid-feedback text-center">
                      {{ this.errorResend }}
                    </div>
                  </label>
                  <div class="font-xs text-center text-success">
                    {{ this.success }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p class="text-center">
            <button
            type="submit"
            class="btn btn-primary btn-sm py-2 px-5 rounded-0"
            :disabled="loading">
            <b-spinner v-if="loading" small class="mr-1"></b-spinner>
            INGRESAR
          </button>
          </p>
        </form>
      </div>
    </b-modal>
  </div>
</template>
<script>
import api from '../api';

export default {
  name: 'verify',
  data() {
    return {
      eventData: {},
      form: {
        code: this.$route.params.id,
      },
      error: '',
      success: '',
      errorResend: '',
      loading: false,
      formResend: {
        email: '',
      },
      modalResend: false,
    };
  },
  mounted() {
    this.getEvent();
  },
  created() {
    if (this.form.code) {
      this.onSubmitForm();
    }
  },
  computed: {
    faqs() {
      if (!this.eventData.metadata) return [];
      return JSON.parse(this.getFieldMeta(this.eventData.metadata, 'faq_verify'));
    },
  },
  methods: {
    async getEvent() {
      const res = await api.getDataEvent(this.eventId);
      if (res) {
        this.eventData = res;
      }
    },
    async onSubmitForm() {
      this.loading = true;
      this.error = '';
      const payload = {
        code: this.form.code,
      };
      const url = `${this.apiNode}/check-transaction`;
      const { data: res } = await api.axios.post(url, payload);
      this.loading = false;
      // const transactionId = this.form.code;
      const { transactionId } = res;

      if (!res.success) {
        this.error = res.message;
        return;
      }
      if (res.isPayed === 0) {
        this.error = res.message;
        return;
      }
      this.$router.push({ name: 'Tickets', params: { id: transactionId } });
    },
    onSubmitResend() {
      this.loading = true;
      this.errorResend = '';
      this.success = '';
      const data = {
        email: this.formResend.email,
        activityId: this.eventId,
      };
      const url = '/code-exchange/send-email';
      api.axios.post(url, data).then((res) => {
        const { message, success } = res.data;
        this.loading = false;
        if (!success) {
          this.errorResend = message;
          return;
        }
        this.success = message;
        setTimeout(() => {
          this.modalResend = false;
        }, 2000);
      }).catch(() => {
        this.errorResend = 'Error al verificar código.';
        this.loading = false;
      });
    },
  },
};
</script>
